import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL_V2
export default axios.create({
    headers: {
        'Authorization': process.env.VUE_APP_REG_API_KEY,
    }
})

